import React, { useState } from 'react';
import { EdgeWhitespaceNotice, fieldsWithEdgeWhitespace } from '../../utils/accountFieldHygiene';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AddDistrict.css';

const AddSuperAdmin = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    title: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    // Refused rather than silently trimmed - see utils/accountFieldHygiene.js. The server
    // trims every creation path regardless; this is so the account's owner is handed the
    // username they will actually have to type.
    const dirty = fieldsWithEdgeWhitespace({ Username: formData.username, Email: formData.email });
    if (dirty.length > 0) {
      setError(`Remove the extra space at the start or end of the ${dirty.join(' and ').toLowerCase()} before saving.`);
      return;
    }

    setLoading(true);

    try {
      await axios.post('/api/users/superadmin', formData);
      navigate('/superadmin/users/superadmins');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to create superadmin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Add Superadmin</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <EdgeWhitespaceNotice
            fields={{ Username: formData.username, Email: formData.email }}
            onFix={() => { setError(''); setFormData((f) => ({ ...f, username: (f.username || '').trim(), email: (f.email || '').trim() })); }}
          />

          <div className="form-group">
            <label>Username *</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Password *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={8}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create Superadmin'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/superadmin/users/superadmins')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSuperAdmin;

